export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10786.f095489d.jpg";